var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateView',[_c('TemplatePage',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"container"},[_c('StatisticProjectReportsBlank',{attrs:{"data":_vm.project,"date":{ start: _vm.today.getFullYear() + '-' + _vm.today.getMonth() + '-' + _vm.today.getDate() }}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }